import { render, staticRenderFns } from "./chatBtn.vue?vue&type=template&id=4fa5881c&scoped=true&"
import script from "./chatBtn.vue?vue&type=script&lang=js&"
export * from "./chatBtn.vue?vue&type=script&lang=js&"
import style0 from "./chatBtn.vue?vue&type=style&index=0&id=4fa5881c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5881c",
  null
  
)

export default component.exports